import { useState } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslate } from "@refinedev/core";

import { NotificationFormValues, STEP_FIELDS } from "@modules/notifications/validations";

export function useNotificationForm() {
  const translate = useTranslate();
  const { trigger } = useFormContext<NotificationFormValues>();
  const [activeStep, setActiveStep] = useState(0);
  const [maxVisitedStep, setMaxVisitedStep] = useState(0);

  const steps = [1, 2, 3, 4].map((step) => translate(`notifications_emails_admin.steps.${step}`));
  const isLastStep = activeStep === steps.length - 1;

  const goTo = (step: number) => {
    setActiveStep(step);
    setMaxVisitedStep((prev) => Math.max(prev, step));
  };

  const validateStep = (step: number) => trigger(STEP_FIELDS[step]);

  const handleNext = async () => {
    if (await validateStep(activeStep)) goTo(activeStep + 1);
  };

  const handleBack = () => setActiveStep((prev) => prev - 1);

  // volta livremente; avança pelo stepper só até onde já visitou e se a etapa atual estiver válida
  const handleStep = (step: number) => async () => {
    if (step < activeStep || (step <= maxVisitedStep && (await validateStep(activeStep)))) {
      goTo(step);
    }
  };

  return {
    steps,
    activeStep,
    maxVisitedStep,
    isLastStep,
    handleStep,
    handleNext,
    handleBack,
  };
}
